import { Outlet } from 'react-router-dom';

const Layout1 = () => (
  <div>
    <Outlet />
  </div>
);

export default Layout1;
